import lorcanaCommon from 'img/lorcana_common.svg'
import lorcanaEnchanted from 'img/lorcana_enchanted.svg'
import lorcanaEpic from 'img/lorcana_epic.svg'
import lorcanaIconic from 'img/lorcana_iconic.svg'
import lorcanaLegendary from 'img/lorcana_legendary.svg'
import lorcanaPromo from 'img/lorcana_promo.svg'
import lorcanaRare from 'img/lorcana_rare.svg'
import lorcanaSuperRare from 'img/lorcana_super_rare.svg'
import lorcanaUncommon from 'img/lorcana_uncommon.svg'
import pokemonAceSpecRare from 'img/pokemon_ace_spec_rare.svg'
import pokemonPromo from 'img/pokemon_black_star_promo.svg'
import pokemonCommon from 'img/pokemon_common.svg'
import pokemonDoubleRare from 'img/pokemon_double_rare.svg'
import pokemonIllustrationRare from 'img/pokemon_illustration_rare.svg'
import pokemonRare from 'img/pokemon_rare.svg'
import pokemonSecretRare from 'img/pokemon_secret_rare.svg'
import pokemonShinyRare from 'img/pokemon_shiny_rare.svg'
import pokemonShinyUltraRare from 'img/pokemon_shiny_ultra_rare.svg'
import pokemonSpecialIllustrationRare from 'img/pokemon_special_illustration_rare.svg'
import pokemonUltraRare from 'img/pokemon_ultra_rare.svg'
import pokemonUncommon from 'img/pokemon_uncommon.svg'
import riftboundCommon from 'img/riftbound_common.svg'
import riftboundEpic from 'img/riftbound_epic.svg'
import riftboundOvernumbered from 'img/riftbound_overnumbered.svg'
import riftboundRare from 'img/riftbound_rare.svg'
import riftboundUncommon from 'img/riftbound_uncommon.svg'
import { IdGame } from 'shared'

/**
 * Rarity icons, keyed by game and then by Cardmarket rarity name — the same
 * string that reaches RarityBadge (Product.rarity / OrderProduct.rarity).
 *
 * Keyed by the Cardmarket name and not by the internal rarity because the
 * cardmarketRarityToNumberMap of a game is many-to-one: on Pokemon
 * 'Illustration Rare', 'ACE Rare' and 'Double Rare' all collapse onto the same
 * internal rarity, but each has its own icon.
 *
 * A rarity with no entry here falls back to the colored text badge, so this map
 * can stay partial.
 */
export const RARITY_ICONS: Partial<Record<IdGame, Record<string, string>>> = {
  [IdGame.Lorcana]: {
    Common: lorcanaCommon,
    Uncommon: lorcanaUncommon,
    Rare: lorcanaRare,
    'Super Rare': lorcanaSuperRare,
    Legendary: lorcanaLegendary,
    Promo: lorcanaPromo,
    Enchanted: lorcanaEnchanted,
    Epic: lorcanaEpic,
    Iconic: lorcanaIconic,
  },
  [IdGame.Riftbound]: {
    Common: riftboundCommon,
    Uncommon: riftboundUncommon,
    Rare: riftboundRare,
    Epic: riftboundEpic,
    Showcase: riftboundOvernumbered,
  },
  [IdGame.Pokemon]: {
    Common: pokemonCommon,
    Uncommon: pokemonUncommon,
    Rare: pokemonRare,
    'Double Rare': pokemonDoubleRare,
    'Illustration Rare': pokemonIllustrationRare,
    'ACE Rare': pokemonAceSpecRare,
    'Ultra Rare': pokemonUltraRare,
    'Special Illustration Rare': pokemonSpecialIllustrationRare,
    'Secret Rare': pokemonSecretRare,
    'Shiny Rare': pokemonShinyRare,
    'Shiny Ultra Rare': pokemonShinyUltraRare,
    Promo: pokemonPromo,
  },
}
